import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class;
import { action, computed } from 'mobx';
import { Model } from 'core/model/Model';
let RbacPermModel = (_class = class RbacPermModel extends Model {
  setLabelBasedAccess(newValue) {
    this.set('labelBasedAccess', newValue);
    if (!newValue) {
      this.set('label_metadata', []);
    }
  }
  get isLabelBasedAccess() {
    if (this.get('labelBasedAccess') !== undefined) {
      return this.get('labelBasedAccess');
    }
    if (this.get('label_metadata')?.length) {
      return true;
    }
    return false;
  }
  get groupLabels() {
    const labels = new Set();
    // I'm not understanding how this works, but it seems calling this.collection.each causes  adjacent rows to rerender.
    // Hencing achieving update labels in one row also updates group labels in another row.
    this.collection?.each(perm => {
      const label_metadata = perm.get('label_metadata');
      if (perm.get('group') === this.get('group') && Array.isArray(label_metadata)) {
        label_metadata.forEach(l => labels.add(l));
      }
    });
    return [...labels];
  }
}, _applyDecoratedDescriptor(_class.prototype, "setLabelBasedAccess", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setLabelBasedAccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLabelBasedAccess", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLabelBasedAccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "groupLabels", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "groupLabels"), _class.prototype), _class);
export { RbacPermModel as default };